export default __webpack_public_path__ + "static/media/Grips of the Faceless Sphinx.3a54ee45.jpg";